import { atom } from "jotai";
import { mainAtom, groupByCheckAtom } from "./main.atoms";
import { quickFilterInfoAtom } from "../deductionFilter";
import { getRemittancesAtom } from "../remittance/remittance.actions";
import { getRemittanceItemsAtom } from "../remittanceItem/remittanceItem.actions";
import {
  ResolveDeductionFetchModeUseCase,
} from "@/core/usecases/deduction";
import { DeductionFetchMode } from "@/core/deduction/FetchMode";

// Update search remittance
export const setSearchRemittanceAtom = atom(null, (get, set, value: string) => {
  set(mainAtom, {
    ...get(mainAtom),
    searchRemittance: value,
  });
});

export const setGroupByCheckAtom = atom(null, (get, set, value: boolean) => {
  set(mainAtom, {
    ...get(mainAtom),
    groupByCheck: value,
  });
});

export const setGroupByCheckManuallyAtom = atom(null, (get, set, value: boolean) => {
  set(mainAtom, {
    ...get(mainAtom),
    groupByCheck: value,
    isGroupByCheckManuallySet: true,
  });
});

/**
 * Unified entrypoint the presentation layer calls to load the deduction list.
 *
 * Resolves the fetch mode from `{ statusId, groupByCheck }` via
 * `ResolveDeductionFetchModeUseCase`, then delegates to the correct feature
 * slice action. Keeps the branching decision in one place so components
 * stay thin.
 */
export const fetchDeductionListAtom = atom(null, async (get, set, refetch?: boolean) => {
  const { statusId } = get(quickFilterInfoAtom);
  const groupByCheck = get(groupByCheckAtom);
  const mode = new ResolveDeductionFetchModeUseCase().execute({ statusId, groupByCheck });

  if (mode === DeductionFetchMode.RemittanceGrouped) {
    await set(getRemittancesAtom, refetch);
    return;
  }
  await set(getRemittanceItemsAtom, refetch);
});
